import {
  createClient,
  QueryGenqlSelection,
} from '@rematter/frontend-lib-api-client';
import { atom, getDefaultStore } from 'jotai';

import { config } from '~/config';
import { $accessToken } from '~/shared/providers/auth/identity.localState';

export type AdHocEvaluatedFormula = {
  formula: string;
  value: number | null;
  error: string | null;
};

const BASE_GRAPHQL_URL = `${config.api.url}/graphql`;

export const $evaluateAdHocFormulas = atom(
  null,
  async (_get, _set, formulas: string[]): Promise<AdHocEvaluatedFormula[]> => {
    if (formulas.length === 0) return [];

    const accessToken = getDefaultStore().get($accessToken);

    const client = createClient({
      url: `${BASE_GRAPHQL_URL}?q=query.pricing.evaluateAdHocFormulas`,
      headers: {
        'Content-Type': 'application/json',
        ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
      },
      credentials: 'include',
    });

    const result = await client.query({
      evaluateAdHocFormulas: {
        __args: { formulas },
        formula: true,
        value: true,
        error: true,
      },
    } satisfies QueryGenqlSelection);

    return (result.evaluateAdHocFormulas ?? []).map((ef) => ({
      formula: ef.formula,
      value: ef.value != null ? Number(ef.value) : null,
      error: ef.error ?? null,
    }));
  },
);
